import { OrderInboundsIcon } from '@/components/locations/order-inbounds-icon';
import { type StyleProp, TouchableOpacity, type ViewStyle } from 'react-native';
import { useTheme } from '@/contexts/theme-context';

interface Props {
  containerStyle?: StyleProp<ViewStyle>;
  iconColor?: string;
  onPress?: () => void;
}

export const I2HeaderButton: React.FC<Props> = ({
  containerStyle,
  iconColor,
  onPress,
}) => {
  const theme = useTheme();

  return (
    <TouchableOpacity
      accessibilityLabel="inbounds button"
      onPress={onPress}
      style={containerStyle}
    >
      <OrderInboundsIcon iconColor={iconColor ?? theme.colors.white} />
    </TouchableOpacity>
  );
};
